import React from "react";

const Maintenance = () => {
  return (
    <main className="maintenance-page">
      <div className="maintenance-page__card">
        <div className="maintenance-page__icon-wrap">
          <svg
            className="maintenance-page__icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            aria-hidden="true"
          >
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v5l3 2" />
          </svg>
        </div>
        <h1 className="maintenance-page__title">Estaremos de vuelta pronto</h1>
        <p className="maintenance-page__subtitle">
          Estamos realizando mejoras para ofrecerte una mejor experiencia.
        </p>
        <p className="maintenance-page__apology">
          Lamentamos los inconvenientes. Gracias por tu paciencia.
        </p>
        <div className="maintenance-page__brand">
          <span className="maintenance-page__heart" aria-hidden="true">
            ♥
          </span>
          <span>La Relojería</span>
        </div>
      </div>
    </main>
  );
};

export default Maintenance;
